package com.castly.admin.ui

import androidx.compose.runtime.*
import com.castly.admin.api.ApiClient
import com.castly.admin.ui.authors.AuthorListPage

@Composable
fun AuthorsSection(apiClient: ApiClient) {
    AuthorListPage(apiClient)
}
